import type { MonthPickerMonth } from '../../types';

export const formatTravelMonthsParam = (travelMonths: MonthPickerMonth[] | undefined): string | null =>
    travelMonths && travelMonths.length !== 0
        ? travelMonths.map((month) => `${month.year}-${`0${month.month}`.slice(-2)}`).join(', ')
        : null;
